import {kSystemImages} from "../../../constants/images";

export default function ErrorScreenImage() {
    // Used in ErrorScreen to display a full screen
    // image for not found routes

    // BUILD
    return (
        <div className={`overflow-hidden h-[320px] min-h-[320px]`}>
            <img className={`object-cover h-full`}
                 src={kSystemImages.routeNotFound}
                 alt="Page non trouvée" />
        </div>
    );
}